import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Typography } from '../../Typography';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';

const StandaloneTextBody = ({ text, style }) => {
  const OPTIONS = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        if (style === 'Subtitle') {
          return <Typography.SUBTITLE>{children}</Typography.SUBTITLE>;
        } else if (style === 'Legal') {
          return <Typography.LEGAL>{children}</Typography.LEGAL>;
        }
        return <Typography.BODY>{children}</Typography.BODY>;
      }
    }
  });
  return <>{documentToReactComponents(text, OPTIONS)}</>;
};

export default StandaloneTextBody;
